import { Dialog } from '@angular/cdk/dialog';
import { Injectable } from '@angular/core';
import { ImageDialogData, ImageViewerComponent } from './image-viewer.component';

@Injectable({
  providedIn: 'root',
})
export class ImageViewerService {
  constructor(private dialog: Dialog) {}

  showImage(name: string, url: string) {
    const data: ImageDialogData = {
      name: name,
      url: url,
    };

    const ref = this.dialog.open(ImageViewerComponent, {
      width: '700px',
      panelClass: 'img-viewer',
      data,
    });

    return ref.closed;
  }
}
